module.exports = __webpack_public_path__ + "static/media/Test41.2857e1c8.bmp";